module.exports = __webpack_public_path__ + "img/Medcom_(2019).ad04fb6f.png";